import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logo_principal_716x120px.svg")